<template>
  <div>
    <div class="row ptb10">
      <div class="col-xs-6 font14">Keypad Artwork Approval Form</div>
      <div class="col-xs-6 text-right">
        <img src="../../assets/images/logo_v2.0.png" width="120px" alt />
      </div>
    </div>
    <table class="table-bordered w100">
      <tr>
        <td class="w70">Product Image</td>
        <td class="w15">Project</td>
        <td class="w15 font13">{{ artwork.project }}</td>
      </tr>
      <tr>
        <td rowspan="25" align="middle" class="text-center">
          <div ref="mypanel" class="inlineb">
            <img :src="checkImg(artwork.img)" :class="$store.getters.hOrV" />
          </div>
        </td>
        <td>Room Type</td>
        <td class="font13">{{ artwork.roomtype }}</td>
      </tr>
      <tr>
        <td>Reference</td>
        <td class="font13">{{artwork.name}}</td>
      </tr>
      <tr>
        <td>Quantity</td>
        <td class="font13">{{ artwork.quantity }}</td>
      </tr>
      <tr class="nob">
        <td>Product Code</td>
        <td class="font13">{{artwork.productCode}}</td>
      </tr>
      <tr class="nob">
        <td>Product Line</td>
        <td class="font13">{{artwork.productLine || ''}}</td>
      </tr>
      <tr class="nob" v-if="showFrameMaterialAndColor">
        <td>Frame Material</td>
        <td class="font13">{{($store.state.productCode.opt4[artwork.frameColor] == 'G') ? 'G - Glass' : 'M - Metal'}}</td>
      </tr>
      <tr class="nob" v-if="showFrameMaterialAndColor">
        <td>Frame Color</td>
        <td class="font13">{{ finishText(artwork, 'frameColor') }}</td>
      </tr>
      <tr class="nob">
        <td>Front End Material</td>
        <td class="font13">{{($store.state.artwork.type == 'blackjack') ? 'M - Metal' : 'G - Glass'}}</td>
      </tr>
      <tr class="nob">
        <td>Front End Color</td>
        <td class="font13">{{ finishText(artwork, (artwork.type == 'alba') ? 'keyColor' : 'frameColor') }}</td>
      </tr>
      <tr class="nob">
        <td>Physical Interface</td>
        <td class="font13">{{artwork.protocol}}</td>
      </tr>
      <tr class="nob">
        <td>Dimensions</td>
        <td class="font13">{{dimensions}}</td>
      </tr>
      <tr class="nob">
        <td>Display Color</td>
        <td class="font13">{{displayColor}}</td>
      </tr>
      <tr class="nob">
        <td>Icon Paint Color</td>
        <td class="font13">No Color</td>
      </tr>
      <tr class="nob">
        <td>Text Paint Color</td>
        <td class="font13">No Color</td>
      </tr>
      <tr class="nob">
        <td>Font Type</td>
        <td class="font13">{{ artwork.fontType }}</td>
      </tr>
      <tr class="nob capitalize" v-if="isLeftIcon">
        <td>{{ leftText }} Icon Size</td>
        <td class="font13">{{ $store.state.iconSizeMap[artwork.iconSize] }}</td>
      </tr>
      <tr class="nob capitalize" v-if="isLeftText">
        <td>{{ leftText }} Text Size</td>
        <td class="font13">{{ $store.state.textSizeMap[artwork.fontSize] }}</td>
      </tr>
      <tr class="nob capitalize" v-if="notSingle && isRightIcon">
        <td>{{ rightText }} Icon Size</td>
        <td class="font13">{{ $store.state.iconSizeMap[($store.getters.isTriple) ? artwork.tripleRightIconSize : artwork.rightIconSize] }}</td>
      </tr>
      <tr class="nob capitalize" v-if="notSingle && isRightText">
        <td>{{ rightText }} Text Size</td>
        <td class="font13">{{ $store.state.textSizeMap[($store.getters.isTriple) ? artwork.tripleRightFontSize : artwork.rightFontSize] }}</td>
      </tr>
      <tr class="nob">
        <td>{{ leftText }} Back End</td>
        <td class="font13">{{ productDatabase.SKU_Finished2 }}</td>
      </tr>
      <tr class="nob">
        <td>{{ leftText }} Front End</td>
        <td class="font13">{{ productDatabase.SKU_Finished4 }}</td>
      </tr>
      <tr class="nob" v-if="notSingle">
        <td>{{ rightText }} Back End</td>
        <td class="font13">{{ productDatabase.SKU_Finished3 }}</td>
      </tr>
      <tr class="nob" v-if="artwork.type == 'alba' && notSingle" >
        <td>{{ rightText }} Front End</td>
        <td class="font13">{{ productDatabase.SKU_Finished5 }}</td>
      </tr>
      <tr class="nob" v-if="$store.getters.isTriple">
        <td>Middle Back End</td>
        <td class="font13">{{ productDatabase.SKU_Finished7 }}</td>
      </tr>
      <tr class="nob" v-if="(artwork.type == 'alba' && $store.getters.isTriple)" >
        <td>Middle Front End</td>
        <td class="font13">{{ productDatabase.SKU_Finished8 }}</td>
      </tr>
      <tr class="" v-if="artwork.type == 'alba'">
        <td>Frame</td>
        <td class="font13">{{ productDatabase.SKU_Finished6 }}</td>
      </tr>
      <tr>
        <td>Approval Date</td>
        <td class="h50"></td>
      </tr>
      <tr>
        <td>Stamp / Signature</td>
        <td class="h100"></td>
      </tr>
    </table>
    <div class="row ptb10">
      <div class="col-xs-4 font10">
        Ref. ID# {{ artwork.serial_number}}
      </div>
      <div
        class="col-xs-4 text-right font10"
      >* Keypad backlight colors are set during installation</div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  props: ["artwork"],
  data() {
    return {
      productDatabase: {}
    };
  },
  computed: {
    showFrameMaterialAndColor() {
      return this.artwork.type == 'alba' || this.artwork.type == 'blackjack'
    },
    displayColor() {
      var a = ['TT', 'M1'];
      return (a.includes(this.artwork.layout) || 
      (this.$store.getters.isDouble && a.includes(this.artwork.rightLayout)) || 
      (this.$store.getters.isTriple && a.includes(this.artwork.tripleRightLayout))) ? 'White' : 'N/A';
    },
    dimensions() {
      var dim = {
        single : '95x95mm',
        double: '195x95mm',
        vdouble: '95x195mm',
        triple: '295x95mm',
        vtriple: '95x295mm'
      };
      return dim[this.artwork.format];
    },
    isLeftIcon() {
      return this.artwork.layoutStyle != 'singleLineText' && this.artwork.layoutStyle != 'doubleLineText' && this.artwork.layoutStyle != 'socket';
    },
    isLeftText() {
      return this.artwork.layoutStyle != 'iconOnly' && this.artwork.layoutStyle != 'socket';
    },
    isRightIcon() {
      var layoutStyle = (this.$store.getters.isTriple) ? this.artwork.tripleRightLayoutStyle : this.artwork.rightLayoutStyle;
      return layoutStyle != 'singleLineText' && layoutStyle != 'doubleLineText' && layoutStyle != 'socket'
    },
    isRightText() {
      var layoutStyle = (this.$store.getters.isTriple) ? this.artwork.tripleRightLayoutStyle : this.artwork.rightLayoutStyle;
      return layoutStyle != 'iconOnly' && layoutStyle != 'socket';
    },
    notSingle() {
      return this.artwork.format != 'single';
    },
    leftText() {
      if (this.$store.getters.isVertical) {
        return 'Top';
      } else if (this.artwork.format != 'single') {
        return 'Left';
      } else {
        return '';
      }
    },
    rightText() {
      if (this.$store.getters.isVertical) {
        return 'Bottom';
      } else {
        return 'Right';
      }
    }
  },
  methods: {
    checkImg(img) {
      if (typeof img == 'undefined') return
      if(img.includes('data:image')) {
        return img;
      } else {
        return this.$store.state.serverURL + '/artwork/' + img + '?' + Date.now()
      }
    },
    finishText(item, part) {
      if (Object.keys(item).length == 0) {
        return;
      }
      var str = item[part];
      var code = this.$store.state.productCode.opt5[str];
      var text = {
        'YB' : 'York Black',
				'IW' : 'Ice White',
				'MB' : 'Mars Black',
				'AS' : 'Aluminium Silver',
				'RU' : 'Raw Amber',
				'SW' : 'Sand White',		
				'VG' : 'Venetian Gold',
				'BG' : 'Bronze Gold',
        'SO' : 'Nickel Noir Mat',
				'FA' : 'Nickel Brass',
				'CC' : 'Bronze Medaillie Allemand',
				'CE' : 'Champagne',
      }
      
      return code + ' - ' + text[code];
    },
    async fetchProductDatabase() {
      if (typeof this.artwork.productCode != "undefined" && this.productDatabase) {
        var artworkDetails = {
          type : this.artwork.type,
          keyColor : this.artwork.keyColor,
          frameColor : this.artwork.frameColor,
        }
        var response = await axios.post("/artwork/productdatabase/" + this.artwork.productCode.replace(/ /g, ''), artworkDetails);
        this.productDatabase = response.data;
      }
    }
  },
  mounted() {
      this.fetchProductDatabase();
  },
  watch:  {
    'artwork.productCode'() {
        this.fetchProductDatabase();
    }
  }
};
</script>